import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DropdownComponent } from '../dropdown.component';

@Component({
  selector: 'mpro-static-dropdown',
  templateUrl: './static-dropdown.component.html',
  styleUrls: ['./static-dropdown.component.scss'],
})
export class StaticDropdownComponent implements OnInit {
  @ViewChild(DropdownComponent) public dropdown: DropdownComponent;

  @Input() public inputValue: any;

  @Input() public nameProperty: string = 'name';
  @Input() public options: any[] = [];
  @Input() public title: string;
  @Input() public disabled: boolean = false;

  @Output() public selectionChanged: EventEmitter<any> = new EventEmitter();

  public ngOnInit(): void {
    if (!this.inputValue) {
      this.inputValue = this.options[0];
    }
  }

  public onSelect(selected: any) {
    if (selected.disabled) {
      return;
    }

    if (this.inputValue !== selected) {
      this.selectionChanged.emit(selected);
      this.inputValue = selected;
    }
    this.dropdown.dropdownOpen = false;
  }
}
